import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { FabricSqlLinkedService } from '../linkedservice/fabric-sql.linkedservice';
import { SqlServerTableDataset } from './sql-server-table.dataset';

@Metamodel.model({
    name: ModelConstants.fabricSqlTableDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.SqlDatabase_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.SqlDatabase_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: FabricSqlLinkedService.MODEL
        }
    }
})
export class FabricSqlTableDataset extends SqlServerTableDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
